export default __webpack_public_path__ + "static/media/grenoble.e9b2a916.jpg";